import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-ocean-900 text-white">
      <div className="px-4 md:px-8 lg:px-12 py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="font-serif text-lg font-semibold">
            株式会社JAPANPACIFICDIVERS
          </span>
          <p className="text-sm text-white/60">
            日本の海から、世界の海へ。
          </p>
        </div>
      </div>

      <div className="border-t border-white/10 px-4 md:px-8 lg:px-12 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; 2025 株式会社JAPANPACIFICDIVERS All Rights Reserved.
          </p>
          <Link
            to="/"
            className="text-xs text-white/40 hover:text-white/70 transition-colors"
          >
            プライバシーポリシー
          </Link>
        </div>
      </div>
    </footer>
  );
}
